import { APIClient, JavaAPIClient } from "../lib/apiHelper"

const {get, post, put, remove} = new APIClient()
const { get: _get, remove: _remove, put: _put } = new JavaAPIClient()

export default {
    /**
     * 근로정보 조회
     * @param {*} companyId 
     * @returns 
     */
    list: (companyId, id=null) => _get(`/workScheduleTemplate/${companyId}${id ? '/'+id : ''}`),
    /**
     * 근로정보 추가
     * @param {*} workSystem 
     * @returns
     */
    add: workSystem => post('/workScheduleTemplate', workSystem),
    /**
     * 근로정보 수정
     * @param {*} workSystem 
     * @returns 
     */
    modify: workSystem => put('/workScheduleTemplate', workSystem),
     /**
     * 스케줄정보 삭제
     * @param {*} id
     * @returns
     */
    delete: id => _remove('/restday?id='+id),
    /**
     * 스케쥴 숨기기
     * @param {*} id
     * @returns
     */
    hide: id => _put('/restday/hide?id='+id),
}
